import { ConfigProvider, theme } from "antd";
import "react-perfect-scrollbar/dist/css/styles.css";
import { BrowserRouter } from "react-router-dom";
import Container from "./Components/Container/Index";
import Loader from "./Components/Loader/Index";
import { LoaderProvider } from "./Context/LoaderContext/Index";
import { ModalProvider } from "./Context/ModalContext/Index";
import { useTheme } from "./Context/ThemeContext";
import Routing from "./Routing/Index";
import AuthService from "./Services/auth.service";
import { useEffect, useState } from "react";
import NetworkErrorPage from "./Pages/NetworkErrorPage/NetworkErrorPage";
import useViewportHeight from "./Hooks/useViewportHeight";
import "./App.css";

function App() {
  const { defaultAlgorithm, darkAlgorithm } = theme;
  const { isDarkMode, customTheme } = useTheme();
  const [currentUserCheckComplete, setCurrentUserCheckComplete] =
    useState(false);
  const [hasNetworkError, setHasNetworkError] = useState(false);

  useEffect(() => {
    const handleGlobalError = (event: CustomEvent<Error>) => {
      const error = event.detail;
      if (error.message === "NO_INTERNET") {
        setHasNetworkError(true);
      }
    };

    window.addEventListener("GLOBAL_ERROR", handleGlobalError as EventListener);
    return () => {
      window.removeEventListener(
        "GLOBAL_ERROR",
        handleGlobalError as EventListener
      );
    };
  }, []);

  const customisedTheme = {
    algorithm: [isDarkMode ? darkAlgorithm : defaultAlgorithm],
    token: {
      colorPrimary: customTheme
        ? customTheme?.primaryColor
        : theme.useToken().token.colorPrimary,
      colorPrimaryBg: customTheme
        ? customTheme?.secondaryColor
        : theme.useToken().token.colorPrimaryBg,
    },
    components: {
      Tabs: {
        horizontalItemPadding: "0px 40px",
      },
      Typography: {
        titleMarginTop: 0,
      },
      Button: {
        primaryShadow: "none",
      },
    },
  };

  const checkForLoggedInUser = async () => {
    await AuthService.getInstance().checkTokenAndRestoreCurrentUser();
    console.log(
      "App -> checkForLoggedInUser -> user check complete",
      AuthService.getInstance().getCurrentUser()
    );
    setCurrentUserCheckComplete(true);
  };

  useEffect(() => {
    checkForLoggedInUser();
  }, []);

  useViewportHeight();

  return (
    <ConfigProvider theme={customisedTheme}>
      {hasNetworkError ? (
        <NetworkErrorPage
          onRetry={() => {
            setHasNetworkError(false);
          }}
        />
      ) : (
        <BrowserRouter>
          <LoaderProvider>
            <Loader />
            <Container>
              <ModalProvider>
                {currentUserCheckComplete && <Routing />}
              </ModalProvider>
            </Container>
          </LoaderProvider>
        </BrowserRouter>
      )}
    </ConfigProvider>
  );
}

export default App;
